// eslint-disable-next-line jira/restricted/react-component-props
import React, { type ComponentProps, type ReactNode } from 'react';
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled, { css } from 'styled-components';
import Button from '@atlaskit/button';
import ShortcutIcon from '@atlaskit/icon/core/migration/link-external--shortcut';
import { token } from '@atlaskit/tokens';
import { useIntl } from '@atlassian/jira-intl';
import { messages } from './messages.tsx';

type ButtonProps = ComponentProps<typeof Button>;

type Props = {
	children: ReactNode;
	href: string;
} & Pick<ButtonProps, 'onClick' | 'onAuxClick'>;

/**
 * A link with icon which visually indicates that the link will be opened in a new tab.
 */
export const NewTabLink = ({ href, children, onClick, onAuxClick }: Props) => {
	const { formatMessage } = useIntl();

	return (
		<Button
			appearance="link"
			spacing="none"
			target="_blank"
			href={href}
			iconAfter={
				<IconWrapper>
					<ShortcutIcon label={formatMessage(messages.newTabIconDescription)} LEGACY_size="small" />
				</IconWrapper>
			}
			onClick={onClick}
			onAuxClick={onAuxClick}
		>
			<ButtonText>{children}</ButtonText>
		</Button>
	);
};

const fontWeight400 = css({
	fontWeight: token('font.weight.regular'),
});

// FIXME: type error in object syntax passing result of `css` to `styled
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const ButtonText = styled.span(
	{
		marginRight: token('space.050'),
	},
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	fontWeight400,
);

// FIXME: type error in object syntax passing result of `css` to `styled
// TODO: migrate to object syntax. Autofix is available for many cases. Remove the eslint-disable for @atlaskit/design-system/no-styled-tagged-template-expression to check.
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const IconWrapper = styled.span`
	${fontWeight400}
`;
